import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'
import DataChangeRequestDetails from 'views/company/DataChangeRequestDetails'
import DataChangeRequests from 'views/company/DataChangeRequests'

export default [
  routeWithLayout({ main: DataChangeRequests, path: UrlProvider.getRawUrl('dataChangeRequests') }),
  routeWithLayout({ main: DataChangeRequestDetails, path: UrlProvider.getRawUrl('dataChangeRequests.view') }),
]
